import React, { useState, useContext } from 'react';
import styles from '../AuthForms.module.sass';
import cn from 'classnames';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ConquerContext } from '../../../contexts/ConquerContext';
import { UserContext } from '../../../contexts/UserContext';
import { AUTH_ZONE } from '..';
import Loader from '../../LoaderCircle';
import PasswordInput from '../../PasswordInput';
import CheckInput from '../../CheckInput';

const FORM_STEP = {
    FIRST: 0,
    LAST: 1,
} ;

const RegisterForm = ({ onFinishCallback }) => {

    const conquer = useContext( ConquerContext );
    const userContext = useContext( UserContext );
    
    const [formStep, setFormStep] = useState( FORM_STEP.FIRST );

    const [email, setEmail] = useState( '' );
    const [password, setPassword] = useState( '' );
    const [repeatPassword, setRepeatPassword] = useState( '' );

    const [username, setUsername] = useState( '' );
    const [firstName, setFirstName] = useState( '' );
    const [lastName, setLastName] = useState( '' );
    const [privacyCheck, setPrivacyCheck] = useState( false );
    const [ageCheck, setAgeCheck] = useState( false );
    
    const [isLoading, setIsLoading] = useState( false );
    const [error, setError] =  useState( '' );

    function showError( message ){

        if( typeof message !== 'string' ) message = 'There was an error when executing the register. Please try again.';
        setError( message );
        return false;

    }

    function checkFields(){

        if( !ageCheck ) return showError( 'You need to be more than 13 years old to register in Supersnappy' );
        if( !privacyCheck ) return showError( 'You need to accept our Privacy Policy' );
        if( !/\S+@\S+\.\S+/.test(email) ) return showError( 'The email doesnt have a valid format' );
        if( !username || validUsername(username) ) return showError( 'You need to provide a valid username' );
        if( !firstName ) return showError( 'You need to provide a valid firstName' );
        if( !lastName ) return showError( 'You need to provide a valid lastName' );
        if( !password || password.length < 8 || password.length > 16 ) return showError( 'You need to provide a valid password. Min 8 chars and max 16 chars' );
        if( password != repeatPassword ) return showError( 'The password doesnt match' );

        setError('');

        return true;

    }

    function validUsername( text ){
        const chars = '/@#$%^& ';
        for ( var z = 0; z<chars.length; z++ ) if( text.includes( chars.charAt(z) ) ) return true;
        return false;
    }

    async function checkUsername(){

        setIsLoading( true );
        let response = await conquer.Username.getOne( username );
        setIsLoading( false );

        return !response || !response.username;

    }

    async function tryToRegister(){

        if( !checkFields() ) return false;
        if( !(await checkUsername()) ) return showError( 'The username already exists' );
        
        setIsLoading( true );
        let response = await conquer.Auth.set( { username, password, email, firstName, lastName } );
        setIsLoading( false );

        if( response.error ) return showError( response.error );
        if( !response.token ) return showError( 'There was an error when executing the register. Please try again.' );

        onFinishCallback?.();

    }

    return (
        <div className={'form'}>
            <div className={styles.form__column}>
                <div className={'fields_container'}>

                {
                    //STEP 1 ===
                    formStep == FORM_STEP.FIRST && <>
                        <input
                            type='email'
                            placeholder='Email'
                            className={error && !isLoading ? 'error' : ''}
                            onChange={(event) => {setEmail(event.target.value)}}
                            value={email}
                        />
                        <PasswordInput 
                            onValueChange={( value )=> { setPassword(value) }} 
                            placeholder='Password'
                            value={password}
                            error={error && !isLoading}
                        />
                        <PasswordInput 
                            onValueChange={( value )=> { setRepeatPassword(value) }} 
                            placeholder='Repeat Password'
                            value={repeatPassword}
                            error={error && !isLoading}
                        />
                    </>
                }

                {
                    //STEP 2 ===
                    formStep == FORM_STEP.LAST && <>
                        <input
                            type='text'
                            placeholder='Username'
                            className={error && !isLoading ? 'error' : ''}
                            onChange={(event) => {setUsername(event.target.value)}}
                            value={username}
                        />
                        <input
                            type='text'
                            placeholder='Firstname'
                            className={error && !isLoading ? 'error' : ''}
                            onChange={(event) => {setFirstName(event.target.value)}}
                            value={firstName}
                        />
                        <input
                            type='text'
                            placeholder='Lastname'
                            className={error && !isLoading ? 'error' : ''}
                            onChange={(event) => {setLastName(event.target.value)}}
                            value={lastName}
                        />
                    </>
                }

                </div>
                {
                    formStep == FORM_STEP.LAST &&
                    <div className={'form_bottom'}>
                        <CheckInput title='I accept the Privacy Policy' onChange={ isChecked => {setPrivacyCheck(isChecked)} }/>
                        <CheckInput title='I am 13 years old or older' onChange={ isChecked => {setAgeCheck(isChecked)} }/>
                    </div>
                }

                { isLoading ? 
                    <Loader /> : 
                    <div className={'btn_container'}>
                        {
                            formStep == FORM_STEP.FIRST ?
                            <button name='Next' className={cn('button', 'primary')} onClick={() => { setFormStep( FORM_STEP.LAST ) }}>
                                Next
                            </button>
                            :
                            <>
                                <button name='Back' className={cn('button', 'secondary')} onClick={() => { setFormStep( FORM_STEP.FIRST ) }}>
                                    Back
                                </button>
                                <button className={cn('button', 'primary')} onClick={tryToRegister}>
                                    Register
                                </button>
                            </>
                        }
                    </div> 
                }
                {error && <p className={'error'}>{error}</p>}
            </div>
        </div>
    );
};

export default RegisterForm;
